<template>
    <div>
        <div class="content-header text-center">
            <h2>Projects</h2>
        </div>
        <div class="container-fluid min-content-height">
            <div class="row">
                <div class="col-md-4 offset-md-4">
                    <div class="card card-body text-center my-4">
                        <a class="btn btn-lg btn-block btn-info btn-load-project" @click="$emit('openModal', {view: 'AddProject', dt: ''})">Create Project <i class="fas fa-plus-circle"></i></a>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-xl-8 offset-xl-2">


                    <div class="card bg-light mb-4" v-for='(data, index) in projects' :key="index">
                        <div class="card-header"><h4>{{data.name}}</h4></div>
                            <div class="card-body">
                                <div class="d-grid gap-2">
                                    <div class="btn-group mb-2" role="group" aria-label="DatasetExists">
                                        <a class="btn col-10 btn-lg btn-outline-primary" @click="$emit('customChangeProject', {shell: 'ProjectDetails', dataset: data.name, project: data.name})"><span class="sidebar-text">Open {{data.name}}</span></a>
                                        <a class="btn col-2 btn-lg btn-danger" @click="deleteProject(data.name)"><i class="fas fa-trash-alt"></i></a>
                                    </div>

                                </div>
                            </div>
                    </div>

                </div>
            </div>
        </div>

    </div>
</template>
<script>
import axios from 'axios';
export default {
    name: 'Projects',
    props: {
        userData: [],
        isAdmin: {
            type: Boolean,
            default() {
                return false
            }
        }
    },
    data(){
        return{
            projects: []
        }
    },
     methods: {
        getProjectsList() {
            console.log('start process');
            axios.post('/projects_list')
                .then(
                (response) => {  
                    this.projects = response.data;
                    console.log('returned list '+JSON.stringify(response.data));
                })
                .catch(
                (error) => {
                this.errorMessage = error.message;
                console.error("There was an error", error);
            }); 

        },
        deleteProject(filename) {
            let formData = new FormData();
            formData.append('projname', filename);
            axios.post('/delete_project', formData)
                .then(
                (response) => {  
                    this.projects = response.data;
                    console.log('returned list '+JSON.stringify(response.data));
                })
                .catch(
                (error) => {
                this.errorMessage = error.message;
                console.error("There was an error", error);
            }); 
        },
        renameProject() {

        }
    },
    mounted() {
        this.getProjectsList();
    }
}
</script>